import { AccordionButton } from '../../../CommonComponents/OPL/Accordion/AccordionButton/AccordionButton';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { RawButton } from '../../../CommonComponents/OPL/Button/Button.styles';
import { Wrapper } from '../../../CommonComponents/OPL/Wrapper/Wrapper';
import styled from '../../../theme/theme';

export const StyledWrapper = styled(Wrapper)(({ theme }) => ({
  flex: 1,
  borderLeft: `1px solid ${theme.colors.neutral[300]}`,
  display: 'flex',
  flexDirection: 'column',
  minWidth: 440,
  maxWidth: 440,
}));

export const Header = styled(Box).attrs({ p: 16 })(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderBottom: `1px solid ${theme.colors.neutral[300]}`,
}));

export const SectionHeader = styled(Box)(({ theme }) => ({
  borderRadius: 0,
  paddingLeft: theme.space[16],
  paddingRight: theme.space[16],
  paddingTop: theme.space[8],
  paddingBottom: theme.space[8],
  backgroundColor: theme.colors.neutral[100],
  color: theme.colors.neutral[500],
  borderBottom: `1px solid ${theme.colors.neutral[200]}`,
}));

export const StyledItem = styled(RawButton)(({ theme, 'aria-pressed': ariaPressed }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: theme.space[8],
  padding: theme.space[16],
  textAlign: 'left',
  border: `1px solid ${theme.colors.neutral[200]}`,
  borderLeft: 'none',
  borderRight: 'none',
  borderRadius: 0,
  background: theme.colors.white,
  color: theme.colors.neutral[600],

  '&&:hover': {
    background: ariaPressed ? theme.colors.primary[200] : theme.colors.neutral[100],
  },

  '&[aria-pressed="true"]': {
    border: `1px solid ${theme.colors.primary[300]}`,
    background: theme.colors.primary[100],
    color: theme.colors.primary[600],
  },
}));

export const StyledAccordionButton = styled(AccordionButton)(({ theme }) => ({
  borderBottom: `1px solid ${theme.colors.neutral[200]}`,
  borderRadius: 0,
}));
